var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGroup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Staff-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.7-Settings-/-Staff-/-Add-member-details",
    transform: "translate(-199.000000, -543.000000)",
    stroke: "currentColor",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells-/-Small-Image-Copy-5",
    transform: "translate(180.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Location-/-Black-Background",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.100000, 5.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,18.088255 L7,17.263675 C7,15.722245 8.29033,14.473225 9.88198,14.473225 C11.47201,14.473225 12.76234,15.722245 12.76234,17.263675 L12.76234,18.088255 L7,18.088255 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625508,11.2555 C8.625508,10.56214 9.187648,10 9.881818,10 C10.574368,10 11.137318,10.56214 11.137318,11.2555 C11.137318,11.94886 10.574368,12.511 9.881818,12.511 C9.187648,12.511 8.625508,11.94886 8.625508,11.2555 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8.088255 L7,7.263675 C7,5.722245 8.29033,4.473225 9.88198,4.473225 C11.47201,4.473225 12.76234,5.722245 12.76234,7.263675 L12.76234,8.088255 L7,8.088255 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625508,1.2555 C8.625508,0.56214 9.187648,-1.687539e-14 9.881818,-1.687539e-14 C10.574368,-1.687539e-14 11.137318,0.56214 11.137318,1.2555 C11.137318,1.94886 10.574368,2.511 9.881818,2.511 C9.187648,2.511 8.625508,1.94886 8.625508,1.2555 Z",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,13.588255 L14,12.763675 C14,11.222245 15.29033,9.973225 16.88198,9.973225 C18.47201,9.973225 19.76234,11.222245 19.76234,12.763675 L19.76234,13.588255 L14,13.588255 Z",
    id: "Stroke-7-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625508,6.7555 C15.625508,6.06214 16.187648,5.5 16.881818,5.5 C17.574368,5.5 18.137318,6.06214 18.137318,6.7555 C18.137318,7.44886 17.574368,8.011 16.881818,8.011 C16.187648,8.011 15.625508,7.44886 15.625508,6.7555 Z",
    id: "Stroke-11-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.11466392e-13,13.588255 L1.11466392e-13,12.763675 C1.11466392e-13,11.222245 1.29033,9.973225 2.88198,9.973225 C4.47201,9.973225 5.76234,11.222245 5.76234,12.763675 L5.76234,13.588255 L1.11466392e-13,13.588255 Z",
    id: "Stroke-7-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625508,6.7555 C1.625508,6.06214 2.187648,5.5 2.881818,5.5 C3.574368,5.5 4.137318,6.06214 4.137318,6.7555 C4.137318,7.44886 3.574368,8.011 2.881818,8.011 C2.187648,8.011 1.625508,7.44886 1.625508,6.7555 Z",
    id: "Stroke-11-Copy-2"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Group.a0688195.svg";
export { ForwardRef as ReactComponent };